export { default } from './GameWandStar'
